export default {
    excess: 'Selvrisiko',
    security: 'Depositum',
    fuel_policy: 'Benzinpolitik',
    like_for_like: 'Identisk erstatning',
    full_to_full: 'Fuld til fuld',
    mileage: 'Afstand: {mileage} miles pr. udlejning',
    unlimited_mileage: 'Ubegrænsede miles',
    non_refundable: 'Ikke-refusionsberettiget',
    free_cancellation_until: 'Gratis annullering indtil {date}',
    cancellation_with_terms: 'Annullering {0} i overensstemmelse med ',
    t_c_text: 'T&C',
    two_free_extras: 'To gratis ekstra ved afhentning',
    glass_tyres_covered: 'Glas og dæk dækkes'
}
